export enum PackagePaginationKeys {
    Page = 'page',
    Count = 'count'
}

export type PackagePagination = {
    [PackagePaginationKeys.Page]?: number;
    [PackagePaginationKeys.Count]?: number;
}
